module.exports = __webpack_public_path__ + "static/media/header.cdf37eed.png";